<ul class="grid row">
    <li *ngFor="let furnitureConfiguration of furnitures" [class.active]="current.furnitureConfiguration === furnitureConfiguration.id" class="col-6">
            <figure (click)="selectFurnitureConfiguration(furnitureConfiguration.id)">
                <span class="media">
                    <img class="vertical" [src]="'assets/img/'+furnitureConfiguration.img" [alt]="furnitureConfiguration.titleRef | translate">
                    <span class="state">
                        <svg class="icon-action-select-thumb" aria-hidden="true">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
                        </svg>
                    </span>
                </span>
                <figcaption>
                    <p>{{ furnitureConfiguration.titleRef | translate }}</p>
                    <p *ngIf="furnitureConfiguration.subTitleRef"><small>{{ furnitureConfiguration.subTitleRef | translate }}</small></p>
                </figcaption>
            </figure>
        </li>
</ul>
<div class="text-center">
    <label class="bt-text" (click)="selectFurnitureConfiguration('')">{{ "need_mapping.no_choice.info" | translate }}</label>
</div>